"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var runCanGrantRole_exports = {};
__export(runCanGrantRole_exports, {
  canGrantRole: () => canGrantRole
});
module.exports = __toCommonJS(runCanGrantRole_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_runHasRole = require("./runHasRole.js");
function canGrantRole(roles, graph, role) {
  const parts = (0, import_types.parseRole)(role);
  switch (parts[0]) {
    case "G":
      switch (parts[1]) {
        case "Superuser":
          return (0, import_runHasRole.hasRole)(roles, (0, import_types.globalRole)("Superuser"));
        case "Admin":
          return (0, import_runHasRole.hasRole)(roles, (0, import_types.globalRole)("Admin"));
        case "MapViewer":
          return (0, import_runHasRole.hasRole)(roles, (0, import_types.globalRole)("Admin"));
        default:
          return (0, import_util.checkExhausted)(parts[1]);
      }
    case "W": {
      const ws = parts[2];
      switch (parts[1]) {
        case "Active":
          return (0, import_runHasRole.hasRole)(roles, import_types.globalAdminRole) || (0, import_runHasRole.hasRole)(roles, (0, import_types.workspaceAdminRole)(ws)) || graph.findProjectsByWorkspaceId(ws).some((p) => (0, import_runHasRole.hasRole)(roles, (0, import_types.projectCoordinatorRole)(p.id))) || graph.findTeamsByWorkspaceId(ws).some((t) => (0, import_runHasRole.hasRole)(roles, (0, import_types.teamCoordinatorRole)(t.id)));
        case "Disabled":
        case "Admin":
          return (0, import_runHasRole.hasRole)(roles, import_types.globalAdminRole) || (0, import_runHasRole.hasRole)(roles, (0, import_types.workspaceAdminRole)(ws));
        case "Owner":
          return (0, import_runHasRole.hasRole)(roles, import_types.superuserRole) || (0, import_runHasRole.hasRole)(roles, (0, import_types.workspaceOwnerRole)(ws));
        default:
          return (0, import_util.checkExhausted)(parts[1]);
      }
    }
    case "P": {
      const p = parts[2];
      const ws = graph.optFindWorkspaceByProjectId(p);
      return (0, import_runHasRole.hasRole)(roles, import_types.globalAdminRole) || (0, import_runHasRole.hasRole)(roles, (0, import_types.projectCoordinatorRole)(p)) || ws != null && (0, import_runHasRole.hasRole)(roles, (0, import_types.workspaceAdminRole)(ws.id));
    }
    case "T": {
      const t = parts[2];
      const relatedAdminsCanGrantTeamRole = () => {
        const ps = graph.findProjectsByTeamId(t);
        const ws = graph.optFindWorkspaceByTeamId(t);
        return (0, import_runHasRole.hasRole)(roles, import_types.globalAdminRole) || ps.every((p) => (0, import_runHasRole.hasRole)(roles, (0, import_types.projectCoordinatorRole)(p.id))) || ws != null && (0, import_runHasRole.hasRole)(roles, (0, import_types.workspaceAdminRole)(ws.id));
      };
      switch (parts[1]) {
        case "Member":
        case "Surveyor":
        case "Approver":
          return (0, import_runHasRole.hasRole)(roles, (0, import_types.teamCoordinatorRole)(t)) || relatedAdminsCanGrantTeamRole();
        case "Coordinator":
          return relatedAdminsCanGrantTeamRole();
        default:
          return (0, import_util.checkExhausted)(parts[1]);
      }
    }
    default:
      return (0, import_util.checkExhausted)(parts[0]);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  canGrantRole
});
//# sourceMappingURL=runCanGrantRole.js.map
